(() => {
  if (window.__ttMachineHeroCta) return;
  window.__ttMachineHeroCta = true;

  const KEY = 'ttFleetMachines';

  function fleet() {
    try {
      const a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a : [];
    } catch (_) {
      return [];
    }
  }

  function writeFleet(next) {
    localStorage.setItem(KEY, JSON.stringify(next));
    syncButtons();
  }

  function syncButtons() {
    const saved = new Set(fleet().map((x) => x.handle));
    document.querySelectorAll('[data-tt-fleet-toggle]').forEach((btn) => {
      const on = saved.has(btn.dataset.machineHandle);
      const label = btn.querySelector('[data-tt-fleet-toggle-label]') || btn;
      if (label) label.textContent = on ? 'Remove from My Fleet' : 'Add to My Fleet';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function toggleFleet(btn) {
    const handle = btn.dataset.machineHandle;
    if (!handle) return;
    const item = {
      handle,
      name: btn.dataset.machineName || handle,
      type: btn.dataset.machineType || '',
      image: btn.dataset.machineImage || '',
      savedAt: Date.now(),
    };
    const exists = fleet().some((x) => x.handle === handle);
    if (exists) writeFleet(fleet().filter((x) => x.handle !== handle));
    else writeFleet([item, ...fleet().filter((x) => x.handle !== handle)]);
  }

  function scrollToParts(e) {
    const t = document.getElementById('tt-hub-parts');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', (e) => {
    const shop = e.target.closest('[data-tt-shop-parts]');
    if (shop) {
      scrollToParts(e);
      return;
    }
    const fleetBtn = e.target.closest('[data-tt-fleet-toggle]');
    if (fleetBtn) {
      e.preventDefault();
      toggleFleet(fleetBtn);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }
})();
